import { BaseModel } from '~/models/baseModel';
import { Moment } from '~/decorators/moment/momentDecorator';
import * as moment from 'moment';

export class TutorialModel extends BaseModel {
    public id:number;
    public thumbnailUrl:string;
    public iframeUrl:string;
    public tutorialType:string;
    public isGroup:boolean;
    public name:string;
    public url:string;
    public urlSegment:string;

    @Moment()
    public publicationDate:moment.Moment;

    get title() : string {
        return this.name;
    }

    public hasThumb() : boolean {
        return (this.thumbnailUrl && this.thumbnailUrl.length > 0);
    }
}
